import TableRequest from 'Core/TableUtility/Models/TableRequest';
import { SecuredClient } from 'Core/Api/SecuredClient';
import ITableDataFetcher from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataFetcher';
import ITableDataResponse from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataResponse';
import {
  SlimOffering,
  GetOfferingsByFilterForCustomerQueryRequest,
  IGetOfferingsByIdForCustomerQueryRequest,
  GetOfferingsByIdForCustomerQueryRequest,
  IGetOfferingsViewModelByIdForCustomerQueryRequest,
  GetOfferingsViewModelByIdForCustomerQueryRequest,
} from 'Core/Api/Api';

export default class OfferingHandler implements ITableDataFetcher<SlimOffering> {
  constructor(props: any) {}

  GetData(tableRequest: TableRequest): Promise<ITableDataResponse<SlimOffering>> {
    return this.GetAllSlimOfferingsByFilter(tableRequest);
  }

  GetAllSlimOfferingsByFilter(
    tableRequest: TableRequest
  ): Promise<ITableDataResponse<SlimOffering>> {
    const client = new SecuredClient();
    client.showLoading = false;
    client.handleGeneralError = true;

    const request = new GetOfferingsByFilterForCustomerQueryRequest(tableRequest);
      request.amountPerPage = 500;

    return client.getOfferingsByFilterForCustomer(request);
  }

  GetOfferingById(request: IGetOfferingsByIdForCustomerQueryRequest) {
    const client = new SecuredClient();
    client.showLoading = true;
    client.handleGeneralError = true;
    const getFilteredMealsForOwnerRequest = new GetOfferingsByIdForCustomerQueryRequest(request);
    return client.getOfferingsByIdForCustomer(getFilteredMealsForOwnerRequest);
  }

  GetOfferingViewModelById(request: IGetOfferingsViewModelByIdForCustomerQueryRequest) {
    const client = new SecuredClient();
    client.showLoading = true;
    client.handleGeneralError = true;
    const offeringRequest = new GetOfferingsViewModelByIdForCustomerQueryRequest(request);
    return client.getOfferingsViewModelByIdForCustomer(offeringRequest);
  }
}
